import React from 'react';
export function Footer() {
  return <footer className="bg-bg-footer border-t border-border-subtle py-16 px-4" data-id="element-110">
      <div className="max-w-4xl mx-auto text-center" data-id="element-111">
        <div className="mb-8" data-id="element-112">
          <div className="inline-block bg-bg-card border border-border-subtle rounded-full px-4 py-2 mb-6" data-id="element-113">
            <span className="text-sm font-semibold text-text-gold" data-id="element-114">
              🔴 EFECTO IMÁN™
            </span>
          </div>
          <h3 className="text-text-primary font-bold text-xl mb-4 max-w-[600px] mx-auto leading-relaxed" data-id="element-115">
            Efecto Imán no es para todos. Es para el tipo que ya se cansó de ser
            un espectador de su propia vida.
          </h3>
          <p className="text-text-secondary mb-8" data-id="element-116">
            Hacé que ella se acerque. Empezá hoy.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 text-text-secondary mb-10" data-id="element-117">
          <a href="mailto:soporte@efectoiman.com" className="hover:text-gold-primary transition-colors text-sm" data-id="element-118">
            📧 soporte@efectoiman.com
          </a>
          <a href="#" className="hover:text-gold-primary transition-colors text-sm" data-id="element-119">
            📲 @efectoiman
          </a>
        </div>

        <p className="text-text-muted text-xs mb-6" data-id="element-120">
          © Efecto Imán™ 2026 — Todos los derechos reservados.
        </p>

        <p className="text-text-gold italic text-lg font-semibold" data-id="element-121">
          "Hacé que ella se acerque. Empezá hoy."
        </p>
      </div>
    </footer>;
}